import { useSelector } from "react-redux";
import { selectIsMobile } from "modules/deviceInfo";
import useWhitelabelMode, {
  WhitelabelMode,
} from "../../hooks/useWhitelabelMode";
import { useStyles } from "./styles";
import BaseLogo from "../BaseLogo";

const PresentationModeLogo = () => {
  const classes = useStyles();
  const isMobileView = useSelector(selectIsMobile);
  const [whitelabelMode, logoURL] = useWhitelabelMode();
  const VARIANT = "powered-by-presentation";

  // we do not show the presentation mode logo on mobile, as it's too crowded already
  if (isMobileView) return null;

  if (
    whitelabelMode === WhitelabelMode.CUSTOM_EVENT_BRANDING_LOGO ||
    whitelabelMode === WhitelabelMode.CUSTOM_EVENT_COMPANY_LOGO
  ) {
    return (
      <BaseLogo
        avatarLogoURL={logoURL}
        logoVariant={VARIANT}
        containerClass={classes.container}
      />
    );
  }

  return <BaseLogo logoVariant={VARIANT} containerClass={classes.container} />;
};

export default PresentationModeLogo;
